<template lang="pug">
.layout-wrapper
    div(id="attention")
    header.header
        .header__inner
            a(:href="siteTop").logo
                img(src="/imgs/logo.png" alt="ALBION ONLINE STORE").logo__img
    AppMain
        router-view
    template(v-if="uiStore.isProgress")
        ProgressCircular

    footer(class="footer")
        .footer-line
            .line
        .footer__inner
            .footer__nav
                ul.footer__navList.--other
                    li.footer__navListItem
                        a(:href="getECSiteUrl('/s/faq_top.aspx')").footer__navLink.--notBefore よくあるご質問
                    li.footer__navListItem
                        a(:href="getECSiteUrl('/s/rule.aspx')").footer__navLink.--notBefore ALBION Beauty Program利用規約
                    li.footer__navListItem
                        a(:href="getECSiteUrl('/s/rule_site.aspx')").footer__navLink.--notBefore オンラインストア・ブランドサイト利用規約
                    li.footer__navListItem
                        a(:href="getECSiteUrl('/s/privacypolicy.aspx')").footer__navLink.--notBefore プライバシーポリシー
        small.footer__copyright Copyright 2008-2025 ALBION co., LTD. All Rights Reserved.
</template>

<script setup>
    import { computed } from 'vue'
    import { useUi } from '@/store/ui'
    import { useAuth } from '@/store/auth'
    import ProgressCircular from '@/components/atoms/ProgressCircular.vue'
    import AppMain from '@/components/layouts/components/default/AppMain.vue'
    import { useHead } from '@unhead/vue'
    import { albionOfficialEcSiteConfig } from '@baseConfig'

    const uiStore = useUi()
    const authStore = useAuth()
    const siteTop = computed(() => {
        return `/memberscard?provision_shop_code=${authStore.LINELoginData.provisionShopCode}&brandsite=${authStore.LINELoginData.brandSite}`
    })
    useHead({
        titleTemplate: 'ALBION - %s'
    })

    const getECSiteUrl = (uri) => {
        return albionOfficialEcSiteConfig.siteUrl + uri
    }
</script>

<style lang="stylus" scoped>
.header
    position: sticky
    top: 0
    left: 0
    z-index: 1200
    width: 100%
    padding: 0 0 1.4rem
    background: white
    transition: transform .3s linear

    +sp()
        padding: 0

    +reduced-motion()
        transition: none

    .header__inner
        width: 100%
        padding-top: 1.4rem
        text-align: center
        box-shadow: 0px 8px 20px rgba(0, 0, 0, .1)

        +sp()
            position: relative
            z-index: 2
            padding: .5rem 0
            background: #fff
            box-shadow: 0px 4px 10px rgba(0, 0, 0, .15)
            transition: transform .3s linear

        +sp-reduced()
            transition: none

.logo
    display: inline-block
    width: 11.8rem
    height: 4.8rem
    vertical-align: middle

    +sp()
        width: 9.748rem
        height: 3.8rem

.logo__img
    display: block
    width: 100%
    height: 100%
    object-fit: contain

.footer-line
    margin-left: 20px
    margin-right: 20px
    padding-top: 4rem
    padding-bottom: 20px

    .line
        display: none

        +sp()
            display: block

footer
    margin-top: auto

.footer
    width: 100%
    padding: 0 0 2rem

    .footer__inner
        width: 100%
        margin: auto 0 4rem 0

        .footer__nav
            display: grid
            justify-content: center

            +sp()
                display: block
                justify-content: none
                padding: 0 4rem

            .footer__navList
                display: flex
                justify-content: center
                gap: 4rem

                +sp()
                    display: grid
                    grid-template-columns: repeat(2, 1fr)
                    gap: 0

    .footer__copyright
        display: block
        padding: 0 2rem
        font-size: 1rem
        line-height: 100%
        text-align: right
        letter-spacing: .03em
        font-weight: 300

        +sp()
            text-align: center
</style>
